/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';


// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TokenServiceInterface
} from './token.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TokenService extends BaseService implements TokenServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Creates authenticate token
     * Service to create an authenticate token. &lt;hr&gt;  Requires authorization of any of following types:  * USER_AUTH_BASIC * APPLICATION_AUTH_BASIC
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createMyAuthenticateToken(body?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public createMyAuthenticateToken(body?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public createMyAuthenticateToken(body?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public createMyAuthenticateToken(body?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (APPLICATION_AUTH_BASIC) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_AUTH_BASIC', 'Authorization', localVarHeaders, 'Basic ');

        // authentication (USER_AUTH_BASIC) required
        localVarHeaders = this.configuration.addCredentialToHeaders('USER_AUTH_BASIC', 'Authorization', localVarHeaders, 'Basic ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Token/MyAuthenticateToken`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<string>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates authenticate token for user
     * Service to create an authenticate token for an user. &lt;hr&gt;  Requires authorization of any of following types:  * APPLICATION_AUTH_BASIC * APPLICATION_BEARER_TOKEN * OAUTH_APPLICATION_CLIENT_CREDENTIAL
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createUserAuthenticateToken(id: string, body?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public createUserAuthenticateToken(id: string, body?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public createUserAuthenticateToken(id: string, body?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public createUserAuthenticateToken(id: string, body?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling createUserAuthenticateToken.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (APPLICATION_AUTH_BASIC) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_AUTH_BASIC', 'Authorization', localVarHeaders, 'Basic ');

        // authentication (APPLICATION_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_BEARER_TOKEN', 'Authorization', localVarHeaders);

        // authentication (OAUTH_APPLICATION_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_APPLICATION_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Token/User/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<string>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes authenticated token
     * Service to delete the authenticated token. &lt;hr&gt;  Requires authorization of any of following types:  * USER_BEARER_TOKEN * OAUTH_USER_LOGIN_USER_PASSWORD * OAUTH_USER_CLIENT_CREDENTIAL * OAUTH_USER_LOGIN_PRESENTATION * APPLICATION_BEARER_TOKEN * OAUTH_APPLICATION_CLIENT_CREDENTIAL  Token subjects allowed:  * AUTHENTICATE_USER * AUTHENTICATE_PASSWORDLESS_USER * AUTHENTICATE_APPLICATION
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteMyAuthenticateToken(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteMyAuthenticateToken(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteMyAuthenticateToken(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteMyAuthenticateToken(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (APPLICATION_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_BEARER_TOKEN', 'Authorization', localVarHeaders);

        // authentication (OAUTH_APPLICATION_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_APPLICATION_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_LOGIN_PRESENTATION) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_LOGIN_PRESENTATION', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_LOGIN_USER_PASSWORD) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_LOGIN_USER_PASSWORD', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (USER_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('USER_BEARER_TOKEN', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Token/MyAuthenticateToken`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes authenticated token
     * Service to delete the authenticated token. &lt;hr&gt;  Requires authorization of any of following types:  * USER_BEARER_TOKEN * OAUTH_USER_LOGIN_USER_PASSWORD * OAUTH_USER_CLIENT_CREDENTIAL * OAUTH_USER_LOGIN_PRESENTATION * APPLICATION_BEARER_TOKEN * OAUTH_APPLICATION_CLIENT_CREDENTIAL * OTHER_BEARER_TOKEN  Token subjects allowed:  * All subjects are allowed
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteToken(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteToken(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteToken(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteToken(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (APPLICATION_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_BEARER_TOKEN', 'Authorization', localVarHeaders);

        // authentication (OAUTH_APPLICATION_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_APPLICATION_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_LOGIN_PRESENTATION) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_LOGIN_PRESENTATION', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OAUTH_USER_LOGIN_USER_PASSWORD) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_USER_LOGIN_USER_PASSWORD', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (OTHER_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OTHER_BEARER_TOKEN', 'Authorization', localVarHeaders);

        // authentication (USER_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('USER_BEARER_TOKEN', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Token`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
